import moment from 'moment'

const get_token = async () => {
    const usuario = JSON.parse(sessionStorage.getItem('o_mo_user'))
    if (usuario) {
        let token = sessionStorage.getItem('one_token')

        let chave = usuario.id
        let ret = {}
        if (token && token !== '' && token !== 'undefined') {
            token = JSON.parse(token)
            let valid = moment.utc().isBefore(token.exp)
            if (valid) {
                ret = token
            } else {
                ret = algoritimoToken(chave, 'P', moment)
            }
        } else {
            ret = algoritimoToken(chave, 'P', moment)
        }
        return ret
    } else {
        return { token: "", exp: moment().add(5, 'minutes').valueOf() }
    }
}

export default get_token

function algoritimoToken(chave, tipo, moment) {
    let timestamp = moment.utc().unix()
    let timestampM = timestamp * 1000

    let digito_verificador = gera_digito_verificador(chave, timestampM.toString())
    let token = tipo + '-' + chave + '-' + timestampM + '-' + digito_verificador
    token = encodeToken(token)

    let dateMore5M = moment.unix(timestamp).add(5, 'minutes').valueOf() // Adiciona 5 minutos a partir da data usada pra gerar o token
    let ret = { token, exp: dateMore5M }

    sessionStorage.setItem('one_token', JSON.stringify(ret))
    return ret
}

function gera_digito_verificador(chave1, chave2) {
    let chave = (chave1 + chave2).toString()
    let length = chave.length + 2

    let aux = []
    for (let i = 0; i < length - 2; i++) {
        aux.push(chave[i] * (length - 1 - i))
    }

    let first = null
    for (let i = 0; i < aux.length; i++) {
        first = first + aux[i]
    }

    first = length - (first % length)
    if (first >= 10) {
        first = 0
    }

    chave += first.toString()

    // devare aux;
    aux = []
    for (let i = 0; i < length - 1; i++) {
        aux.push(chave[i] * (length - i))
    }

    let second = null
    for (let i = 0; i < aux.length; i++) {
        second = second + aux[i]
    }

    second = length - (second % length)
    if (second >= 10) {
        second = 0
    }

    return first + second.toString()
}

function encodeToken(token) {
    let token64 = btoa(token)
    let tokenAux = []
    tokenAux[0] = token64.substring(0, token64.length / 2)
    tokenAux[1] = token64.substring(token64.length / 2, token64.length)

    token = ""
    for (let i = 0; i < tokenAux[0].length; i++) {
        token += tokenAux[1][tokenAux[1].length - 1 - i] + tokenAux[0][i]
    }

    return token
}
